import React from "react";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { _t } from "../../../app/i18n/i18n";

export const IconButtons = ({ options, onClick, activeOption }) => {
  options = options.filter((pref) => !pref.appPreference);

  return (
    <ToggleButtonGroup type="radio" name="options" defaultValue={activeOption.label} className="d-block ml-2">
      {options.map((option, key) => iconButton({ option, key, onClick: () => onClick(option) }))}
    </ToggleButtonGroup>
  );
};

// ToggleButton needs to be direct child if ToggleButtonGroup, so no intermediate components here.
function iconButton({ option, key, onClick }) {
  if (!option.label) return null;

  return (
    <ToggleButton
      type="radio"
      key={key}
      value={option.label}
      onClick={onClick}
      className={"border-0 border-radius-0 p-2 text-center bg-dark"}
      style={{ width: "95px" }}
    >
      <i className={`fa ${option.icon} d-block fa-2x mx-auto `} />
      {_t(option.label)}
    </ToggleButton>
  );
}
